import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import ImagePicker from "@/components/admin/ImagePicker";
import { toast } from "sonner";

export default function AboutManager() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/about").then((r) => setData(r.data));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/content/about", data);
      toast.success("About updated");
    } catch {
      toast.error("Could not save");
    } finally {
      setSaving(false);
    }
  };

  if (!data) return <div className="text-earth-600">Loading…</div>;

  return (
    <div data-testid="about-manager">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.22em] text-sage-600">Edit</div>
        <h1 className="font-serif text-4xl text-earth-900 mt-2 font-light">About</h1>
      </div>
      <div className="bg-white rounded-2xl p-8 border border-earth-100 flex flex-col gap-5">
        <div>
          <Label>Title</Label>
          <Input className="mt-2" value={data.title || ""} onChange={(e) => setData({ ...data, title: e.target.value })} data-testid="about-title" />
        </div>
        <div>
          <Label>Body</Label>
          <Textarea className="mt-2" rows={8} value={data.body || ""} onChange={(e) => setData({ ...data, body: e.target.value })} data-testid="about-body" />
        </div>
        <ImagePicker
          label="Image"
          value={data.image}
          onChange={(v) => setData({ ...data, image: v })}
          testId="about-image"
          aspect="aspect-[4/3]"
        />
        <div>
          <Button onClick={save} disabled={saving} className="bg-earth-900 text-white hover:bg-earth-800 rounded-full px-8" data-testid="about-save-btn">
            {saving ? "Saving…" : "Save changes"}
          </Button>
        </div>
      </div>
    </div>
  );
}
